import styled from "@emotion/styled";
import { MDSButton } from "@/mds";

export const AppDownloadButton = styled(MDSButton)`
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => theme.spacing[7]} ${({ theme }) => theme.spacing[5]};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  transition: background-color 0.2s ease-in-out;
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.button.transparent.hover};
  }
`;

export const AppIconWrapper = styled.div<{ isApple?: boolean }>`
  padding: ${({ theme }) => theme.spacing[2]};
  margin-top: ${({ isApple }) => (isApple ? "-2px" : "0")};
`;
